import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportMavenirConfig } from '@api/dataSources';

import { ESnackbarTypes } from '@enums/common';

import { MAVENIR_CONFIG_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useMutateMavenirConfigExport() {
	const dispatch = useAppDispatch();

	const {
		mutate: exportConfig,
		isLoading: isLoadingExportConfig,
	} = useMutation<string>({
		mutationKey: [MAVENIR_CONFIG_EXPORT],
		mutationFn: exportMavenirConfig,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportConfig,
		isLoadingExportConfig,
	};
}
